import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
    DeleteRecord,
    GetListview,
    SuccessAlert,
    URLPRIFIX,
    ErrorAlert,
    GetStatusCounts
} from "../../functions/api";
import { useStore } from "../../Components/StateProvider"
import Pagination from "../../Components/Fields/Pagination"; // Ensure this import is used if Pagination component is part of your UI
import { getlocal } from "../../functions/localstorage";
import StatusTabs from "../../Components/Elements/StatusTabs";
import ListViewUp from "../../Components/Elements/ListViewUp";

const FormListUpd = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const user = getlocal("system")?.user || {};
    const [activeTab, setActiveTab] = useState("ALL");
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [statusTabs, setStatusTabs] = useState([]);

    const [hasTabClicked, setHasTabClicked] = useState(false);
    const statusCountURL = "/forms/getformstatuscount";

    const tablename = "forms";
    const tableURL = "/forms/getformslist";
    const DeleteURL = "/users/deleteusers/";

    const getDynamicTableURL = () => {
        return user.role === 1 ? tableURL : tableURL + "/" + user.id;
    };

    const [filters, setFilters] = useState({});
    const [sortConfig, setSortConfig] = useState({
        field: "",
        direction: "asc",
    });

    const Tablehead = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
    const Tablerecord = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";
    const width = "100%";
    const height = "90%";

    const Header = [
        ["Name of Artist", "name_of_Artist"],
        ["Film", "film"],
        ["E-Mail", "email"],
        ["Category Name", "categoryName"],
        ["Status", "status"],
        ["Submitted Date", "created_date"]
    ];

    const store = useStore();
    const init = {
        filterfield: "all",
        search: "",
        sort: "desc",
        currentpage: 1,
        totalpage: 1,
        pagesize: 20,
    };


    const loadListview = useCallback((params = {}) => {
        // Ensure loadListview uses the derived filter parameters for the API call
        GetListview({
            listUrl: getDynamicTableURL(),
            store,
            field: params.field ?? store.getvalue("formfilterfield") ?? init.filterfield,
            search: params.search ?? store.getvalue("formsearch") ?? init.search,
            sort: params.sort ?? store.getvalue("formsort") ?? init.sort,
            page: params.page ?? store.getvalue("formCurrentPage") ?? init.currentpage,
            pagesize: params.pagesize ?? store.getvalue("formpagesize") ?? init.pagesize,
        });


    }, [store, getDynamicTableURL]);

    useEffect(() => {
        store.setmodule("forms", init).then(() => {
            fetchStatusCounts();
            store.setheader(`${tablename} List`);

            store.stopLoading();

            // Get stored values
            const storedFilters = store.getvalue("formFilters");
            const storedField = queryParams.get("field") || store.getvalue("formfilterfield") || "all";
            const storedSearch = queryParams.get("search") || store.getvalue("formsearch") || "";
            const storedSort = queryParams.get("sort") || store.getvalue("formsort") || "desc";
            const storedPage = store.getvalue("formCurrentPage") || 1;
            const storedPageSize = store.getvalue("formpagesize") || 20;
            const storedTab = store.getvalue("formActiveTab") || "ALL";

            // Restore UI state
            if (storedFilters) setFilters(storedFilters);
            setActiveTab(storedTab);
            setHasTabClicked(true); // Prevent future reloads if tab is clicked again

            // Apply filters to reload the list
            change({
                field: storedField,
                search: storedSearch,
                sort: storedSort,
                page: storedPage,
                pagesize: storedPageSize,
            });
        });
    }, []);





    const change = useCallback((props) => {

        // Construct updatedFilters based on the new props and current filters
        const updatedFilters = props.field ? { ...filters, [props.field]: props.search } : {};

        setFilters(updatedFilters);
        store.setvalue("formFilters", updatedFilters);
        store.setvalue("formFilters", { [props.field]: props.search });
        store.setvalue("formfilterfield", props.field);
        store.setvalue("formsearch", props.search);
        store.setvalue("formsort", props.sort);
        store.setvalue("formCurrentPage", props.page);
        store.setvalue("formpagesize", props.pagesize);


        // store.setvalue("formfilterfield", props.field || "all");
        // store.setvalue("formsearch", props.search || "");
        // store.setvalue("formsort", props.sort || init.sort);
        // store.setvalue("formpagesize", props.pagesize || store.getvalue("formdefaultpagesize"));

        loadListview({
            field: props.field,
            search: props.search,
            sort: props.sort,
            page: props.page || 1, // Pass page explicitly
            pagesize: props.pagesize,
        });
    }, [filters, store, loadListview]);

    function onpage(page, pagesize = store.getvalue("formpagesize")) {
        store.setvalue("formCurrentPage", page);
        // When navigating pages, retain existing filter and sort.
        loadListview({
            field: store.getvalue("formfilterfield"),
            search: store.getvalue("formsearch"),
            sort: store.getvalue("formsort"),
            page,
            pagesize,
        });
    }

    const fetchStatusCounts = useCallback(async () => {
        store.startLoading();
        try {
            const counts = await GetStatusCounts(statusCountURL, store);
            console.log("count", counts);

            if (counts?.statuscount) {
                setStatusTabs(counts.statuscount);
            }
        } catch {
            ErrorAlert("Failed to fetch status counts.");
        } finally {
            store.stopLoading();
        }
    }, []);

    const handleFilterChange = useCallback((label, value) => {
        const updatedFilters = { ...filters, [label]: value };
        setFilters(updatedFilters);
        change({
            field: label,
            search: value,
            pagesize: store.getvalue("documentPageSize"),
            sort: sortConfig.direction,
        });
    }, [filters, sortConfig]);
    // const statusTabs = store.getvalue("statuscount") || [];

    // Handler for individual and "select all" checkboxes
    const handleOnSelect = (itemOrItems, isChecked) => {
        if (Array.isArray(itemOrItems)) {
            // This is for "Select All"
            if (isChecked) {
                setSelectedRecords([...itemOrItems]); // Select all visible filtered records
            } else {
                setSelectedRecords([]); // Deselect all
            }
        } else {
            // This is for individual row selection
            if (isChecked) {
                setSelectedRecords((prevSelected) => [...prevSelected, itemOrItems]);
            } else {
                setSelectedRecords((prevSelected) =>
                    prevSelected.filter((record) => record.id !== itemOrItems.id)
                );
            }
        }
    };

    // Handler for bulk assign action
    const handleBulkAssign = (itemsToAssign) => {
        console.log("Bulk Assign these items:", itemsToAssign);
        alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
        // After successful API call for bulk assign:
        setSelectedRecords([]);
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("formfilterfield"),
            search: store.getvalue("formsearch"),
            sort: store.getvalue("formsort"),
            page: store.getvalue("formCurrentPage"),
            pagesize: store.getvalue("formpagesize"),
        });
    };

    const handleBulkApprove = (itemsToAssign) => {
        console.log("Bulk Assign these items:", itemsToAssign);
        alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
        // After successful API call for bulk assign:
        setSelectedRecords([]);
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("formfilterfield"),
            search: store.getvalue("formsearch"),
            sort: store.getvalue("formsort"),
            page: store.getvalue("formCurrentPage"),
            pagesize: store.getvalue("formpagesize"),
        });
    };

    // Handler for bulk delete action
    const handleBulkDelete = async (itemsToDelete) => {
        console.log("Bulk Delete these items:", itemsToDelete);
        store.startLoading(); // Show loading indicator

        let allSuccess = true;
        for (const item of itemsToDelete) {
            try {
                const res = await DeleteRecord(DeleteURL + item.id, {
                    modifiedBy: store.getuser().id,
                });
                if (!res.success) {
                    allSuccess = false;
                    ErrorAlert(
                        res?.errormessage?.response?.data ||
                        `Error deleting item ${item.id}. Please contact the Admin.`
                    );
                }
            } catch (error) {
                allSuccess = false;
                ErrorAlert(`Error deleting item ${item.id}: ${error.message}`);
            }
        }

        if (allSuccess) {
            SuccessAlert("Selected items deleted successfully!");
        } else {
            ErrorAlert("Some items could not be deleted. Check console for details.");
        }

        setSelectedRecords([]); // Clear selection
        GetListview({
            listUrl: getDynamicTableURL(), // Use dynamic URL here
            store: store,
            field: store.getvalue("formfilterfield"),
            search: store.getvalue("formsearch"),
            sort: store.getvalue("formsort"),
            page: store.getvalue("formCurrentPage"),
            pagesize: store.getvalue("formpagesize"),
        });
        store.stopLoading(); // Hide loading indicator
    };


    // Modified handleClickRow to ONLY redirect to view page if 'view' permission is available
    const handleClickRow = (item) => {
        console.log("Row clicked:", item);
        if (store.getprops("view")) { // Only redirect to view if permission is true
            store.navTo(`/${URLPRIFIX}/${tablename}/view/${item.id}`);
        }
        // No 'else if (store.getprops("update"))' here, so no redirect to edit from row click
    };

    // ListView's internal logic and rendering starts here
    const handleSort = useCallback((label) => {
        const direction = sortConfig.field === label && sortConfig.direction === "asc" ? "desc" : "asc";
        setSortConfig({ field: label, direction });
        // Trigger a change to reload list with new sort config
        change({
            field: store.getvalue("formfilterfield"), // Retain current filter field
            search: store.getvalue("formsearch"), // Retain current search term
            sort: direction,
            pagesize: store.getvalue("formpagesize"), // Retain current page size
            page: 1, // Reset to first page on sort change
        });
    }, [sortConfig, change, store]);

    const records = store.getvalue("list") || []; // Get records from the store

    const filteredRecords = records
        .filter((record) => {
            const upper = activeTab.toUpperCase();
            // Apply tab-specific filtering before general filters
            if (upper !== "ALL" && upper !== "ASSIGNED" && upper !== "UNASSIGNED") {
                if (record.status?.toUpperCase() !== upper) return false;
            }
            if (upper === "ASSIGNED" && !record.assigned_to) return false;
            if (upper === "UNASSIGNED" && record.assigned_to) return false;

            // Apply general filters
            return Header.every(([_, label]) => {
                const filterValue = filters[label];
                if (!filterValue) return true;

                let fieldValue = record[label];
                if (label.toLowerCase().includes("date") && fieldValue) {
                    const parsed = new Date(fieldValue);
                    if (!isNaN(parsed)) fieldValue = parsed.toISOString().split("T")[0];
                }
                return (
                    fieldValue &&
                    fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase())
                );
            });
        })
        .sort((a, b) => {
            const { field, direction } = sortConfig;
            if (!field) return 0;

            const aVal = (a[field] ?? "").toString().toLowerCase();
            const bVal = (b[field] ?? "").toString().toLowerCase();

            if (aVal < bVal) return direction === "asc" ? -1 : 1;
            if (aVal > bVal) return direction === "asc" ? 1 : -1;
            return 0;
        });


    const handleSelectAll = (event) => {
        if (event.target.checked) {
            handleOnSelect(filteredRecords, true); // Select all visible records
        } else {
            handleOnSelect([], false); // Deselect all
        }
    };

    const isAllSelected =
        filteredRecords.length > 0 &&
        selectedRecords.length === filteredRecords.length &&
        filteredRecords.every((record) =>
            selectedRecords.some((sItem) => sItem.id === record.id)
        );

    const isSelected = (item) => selectedRecords.some((sItem) => sItem.id === item.id);

    const handleTabClick = useCallback((status, count) => {
        const upper = status.toUpperCase();
        store.startLoading();
        setActiveTab(status);
        setHasTabClicked(true);
        store.setvalue("formActiveTab", status);
        store.setvalue("formTabClicked", true);

        // Determine field and search based on the clicked tab
        const field = upper === "ASSIGNED" || upper === "UNASSIGNED" ? "assigned_to" : "status";
        const search =
            upper === "ALL" ? "" : upper === "ASSIGNED" ? "gt:0" : upper === "UNASSIGNED" ? "eq:0" : upper;

        // Update filters state and store for consistency
        const filterValue = upper === "ALL" ? {} : { [field]: search };
        setFilters(filterValue);
        store.setvalue("formFilters", filterValue);

        // Adjust pagesize based on count if necessary, or revert to default for "ALL"
        const pageSize = count || init.pagesize; // Use count if available, otherwise default
        store.setvalue("formpagesize", pageSize);

        // Trigger the change function to load data with the new filters
        change({ field, search, pagesize: pageSize, sort: store.getvalue("formsort"), page: 1 }); // Reset to page 1

        setTimeout(() => {
            store.stopLoading();
        }, 200);
    }, [store, change, init.pagesize]);


    const handleClearFilter = useCallback(() => {
        setActiveTab("ALL");
        setFilters({});
        setHasTabClicked(false);
        store.setvalue("formFilters", {});
        store.setvalue("formpagesize", init.pagesize);
        store.setvalue("formfilterfield", init.filterfield);
        store.setvalue("formsearch", init.search);
        store.setvalue("formsort", init.sort);
        store.setvalue("formCurrentPage", init.currentpage);
        store.setvalue("formActiveTab", "ALL");
        store.setvalue("formTabClicked", false);
        loadListview({ ...init }); // Reload with initial state
    }, [store, loadListview, init]);

    const handleDelete = useCallback(async (item) => {
        if (!window.confirm("Are you sure you want to delete?")) return;
        store.startLoading();
        try {
            const res = await DeleteRecord(`${DeleteURL}${item.id}`, {
                modifiedBy: store.getuser().id,
            });
            if (res.success) {
                SuccessAlert("Deleted Successfully");
                setSelectedRecords((prev) => prev.filter((r) => r.id !== item.id));
                loadListview();
                fetchStatusCounts();
            } else {
                ErrorAlert("Error Found. Please contact the Admin.");
            }
        } catch (error) {
            ErrorAlert(`Error deleting item: ${error.message}`);
        } finally {
            store.stopLoading();
        }
    }, []);


    return (
        <div className="grid grid-rows-10 h-full">
            <div className="flex flex-wrap justify-between items-center mb-2 px-2">
                <div className="flex-1 overflow-x-auto">
                    <StatusTabs
                        statusTabs={statusTabs}
                        activeTab={activeTab}
                        onTabClick={handleTabClick}
                        hasTabClicked={hasTabClicked}
                        onClearClick={handleClearFilter}
                    />
                </div>
            </div>

            <div className="row-span-9 h-full w-full">
                <div
                    className="py-5 px-[30px] h-full w-full"
                    contentEditable={false}
                >
                    {/* Integrated ListView Table Structure */}
                    <ListViewUp
                        header={Header}
                        filteredRecords={filteredRecords}
                        Tablehead={Tablehead}
                        Tablerecord={Tablerecord}
                        sortConfig={sortConfig}
                        handleSort={handleSort}
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        store={store}
                        handleOnSelect={handleOnSelect}
                        isSelected={isSelected}
                        handleClickRow={handleClickRow}
                        handleDelete={handleDelete}
                        handleSelectAll={handleSelectAll}
                        isAllSelected={isAllSelected}
                        tablename={tablename}

                    />

                    {/* End of Integrated ListView Table Structure */}

                    <div className="float-right mr-8 mt-6">
                        <Pagination onchange={onpage} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormListUpd;
